import Image from 'next/image';
import React, { Component } from 'react';

class Gallery extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeIndex: 0,
		};
	}

	render() {
		const { images } = this.props;
		const { activeIndex } = this.state;
		const image =
			images.length > 0
				? images[activeIndex].imageUrl
				: require('../../../src/static/images/Product-Image-Coming-Soon.png');
		return (
			<div className="gallery">
				<div className="preview-container">
					<div className="preview-wrapper">
						<div className="preview">
							<Image objectFit="contain" layout="fill" src={image} alt="Item Picture" />
						</div>
					</div>
				</div>

				{images.length > 1 && (
					<div className="selection-container">
						{images.map((item, index) => {
							return (
								<div
									className={`selection-item position-relative ${
										activeIndex === index ? 'active' : ''
									}`}
									key={index}
									onClick={() => this.setState({ activeIndex: index })}>
									<Image layout="fill" objectFit="contain" src={item.imageUrl} alt="Item Picture" />
								</div>
							);
						})}
					</div>
				)}
			</div>
		);
	}
}
export default Gallery;
